import styled from '@emotion/styled';

export const Bold = styled.span(`
    font-weight: 700;
`);

export const SemiBold = styled.span(`
    font-weight: 600;
`);

export const Normal = styled.span(`
    font-weight: 400;
`);

export const Light = styled.span(`
    font-weight: 300;
`);
